import type { WebReducerState } from '../reducers/types';

export const getAuth0LoginFunction = (state: WebReducerState) =>
  state.auth0.login;

export const getAuth0LogoutFunction = (state: WebReducerState) =>
  state.auth0.logout;
